import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataParser from "../../../utlits/Dataparser";
import PastDaysService from "../../../Services/PastDaysService";
import { Helmet } from "react-helmet";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import secureLocalStorage from "react-secure-storage";
import SocketService from "../../../Services/SocketService";
import moment from "moment";
import { Tooltip, message } from "antd";
import TableSkeleton from "../../Reuseable/TableSkeleton";

message.config({ zIndex: 1000000001 });

const PastDaysSettings = () => {
    const navigate = useNavigate();
    const [pastDaysList, setPastDaysList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [userPermissions, setuserPermissions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [days, setDays] = useState("");
    const [daysEdit, setDaysEdit] = useState("");
    const [editID, setEditID] = useState("");
    const [error, setError] = useState("");
    const [itemToDelete, setItemToDelete] = useState(null);

    const companyId = DataParser.CompanyId();

    const handelPageChange = (e, page) => {
        e.preventDefault();
        setCurrentPage(page);
    };

    const getPastDays = () => {
        if (!companyId) return;
        setIsLoading(true);
        PastDaysService.getPastDays(companyId)
            .then((res) => {
                if (res.data === "Un-Athunticated request") {
                    secureLocalStorage.removeItem("adminInfo");
                    secureLocalStorage.removeItem("admins");
                    navigate("/");
                    return;
                }
                const dataset = res.data || [];
                setPastDaysList(Array.isArray(dataset) ? dataset : []);
            })
            .catch((err) => console.error("Error fetching past days:", err))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        getPastDays();
        setuserPermissions(DataParser.CompanyUserPermissions() || []);
    }, [companyId]);

    useEffect(() => {
        SocketService.connect();
        const handleUpdate = (data) => {
            if (Number(data.company_id) === Number(companyId)) getPastDays();
        };
        SocketService.on("pastdays_update", handleUpdate);
        return () => SocketService.off("pastdays_update", handleUpdate);
    }, []);

    const handelDelete = (e, item) => {
        e.preventDefault();
        setItemToDelete(item);
        document.getElementById("openDeletePastDaysModal").click();
    };

    const confirmDelete = async () => {
        if (!itemToDelete) return;
        setPastDaysList((prev) => prev.filter((el) => el._id !== itemToDelete._id));
        document.getElementById("closePastDaysDeleteModal").click();
        try {
            const res = await PastDaysService.deletePastDays(itemToDelete._id);
            if (res.Good) {
                message.success("Record deleted successfully!");
                getPastDays();
            } else {
                message.error("Failed to delete record!");
                getPastDays();
            }
        } catch (err) {
            console.error("Delete error:", err);
            message.error("Failed to delete record!");
            getPastDays();
        }
        setItemToDelete(null);
    };

    const handelSubmit = async (e) => {
        if (e) e.preventDefault();
        if (days === "" || days < 0) {
            setError("Please enter a valid day count!");
            return;
        }
        try {
            const res = await PastDaysService.createPastDays({ days: parseInt(days), company_id: companyId });
            if (res.Good) {
                message.success("Past days setting created successfully!");
                document.getElementById("createPastDaysModalClose").click();
                getPastDays();
                clearCreateState();
            } else {
                message.warning("Failed to create setting.");
            }
        } catch (err) {
            console.error(err);
            message.error("An error occurred.");
        }
    };

    const handelEditSubmit = async (e) => {
        if (e) e.preventDefault();
        if (daysEdit === "" || daysEdit < 0) {
            setError("Please enter a valid day count!");
            return;
        }
        try {
            const res = await PastDaysService.updatePastDays(editID, { days: parseInt(daysEdit) });
            if (res.Good) {
                message.success("Setting updated successfully!");
                document.getElementById("editPastDaysModalClose").click();
                getPastDays();
                clearEditState();
            } else {
                message.warning("Failed to update setting.");
            }
        } catch (err) {
            console.error(err);
            message.error("An error occurred.");
        }
    };

    const handleOpenUpdate = (e, item) => {
        e.preventDefault();
        setDaysEdit(item.days);
        setEditID(item._id);
    };

    const clearCreateState = () => { setDays(""); setError(""); };
    const clearEditState = () => { setDaysEdit(""); setEditID(""); setError(""); };

    const PaginatedData = paginate(pastDaysList, currentPage, pageSize);

    return (
        <>
            <Helmet>
                <title>Past Days Settings - Planit</title>
            </Helmet>
            <div className="main-content">
                <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 px-0">
                                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                                    <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                                        <ol className="breadcrumb mb-0">
                                            <li className="breadcrumb-item">
                                                <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                                            </li>
                                            <li className="breadcrumb-item active">
                                                <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                                            </li>
                                            <li className="breadcrumb-item active">Past Days</li>
                                        </ol>
                                        {pastDaysList.length === 0 && (
                                            <button
                                                type="button"
                                                className="btn btn-primary waves-effect waves-light"
                                                style={{ borderRadius: "5px" }}
                                                data-bs-toggle="modal"
                                                data-bs-target="#createPastDaysModal"
                                            >
                                                Create Past Days
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12 px-0">
                                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                                    <div className="card-body p-0">
                                        <div className="table-responsive listing-table-wrapper">
                                            <table className="table mb-0 custom-table listing-table">
                                                <thead>
                                                    <tr className="tableHeaderbg">
                                                        <th>Sr#</th>
                                                        <th>Days</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <TableSkeleton cols={3} rows={6} />
                                                    ) : PaginatedData.length > 0 ? (
                                                        PaginatedData.map((item, index) => (
                                                            <tr key={item._id}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.days}</td>
                                                                <td className="tableset">
                                                                    <Link to="#" className="cursor-pointer iconscolor" onClick={(e) => handelDelete(e, item)}>
                                                                        <Tooltip title="Delete">
                                                                            <i className="uil-trash iconscolor" />
                                                                        </Tooltip>
                                                                    </Link>
                                                                    <Link
                                                                        to="#"
                                                                        className="cursor-pointer iconscolor"
                                                                        onClick={(e) => handleOpenUpdate(e, item)}
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#editPastDaysModal"
                                                                    >
                                                                        <Tooltip title="Edit">
                                                                            <i className="uil-pen iconscolor" />
                                                                        </Tooltip>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="3" className="text-center">
                                                                No records found. Click 'Create Past Days' to add one.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>

                                            {pastDaysList.length > pageSize && (
                                                <div className="d-flex justify-content-center mt-4">
                                                    <Pagination
                                                        itemCount={pastDaysList.length}
                                                        currentPage={currentPage}
                                                        pageSize={pageSize}
                                                        onPageChange={handelPageChange}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Hidden trigger for delete modal */}
                <div id="openDeletePastDaysModal" data-bs-toggle="modal" data-bs-target="#deletePastDaysModal" style={{ display: "none" }} />

                {/* Delete Confirmation Modal */}
                <div id="deletePastDaysModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
                    <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
                        <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                            <div className="modal-header border-0 pb-1">
                                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Past Days Setting</h5>
                                <button type="button" className="btn-close" id="closePastDaysDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
                            </div>
                            <div className="modal-body pt-2 pb-2">
                                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this past day setting?</p>
                                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                                    <i className="uil uil-exclamation-triangle me-1" />
                                    This action cannot be undone.
                                </p>
                            </div>
                            <div className="modal-footer border-0 pt-1">
                                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Create Modal */}
                <div
                    id="createPastDaysModal"
                    className="modal fade"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                    data-bs-keyboard="false"
                >
                    <form onSubmit={handelSubmit}>
                        <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
                            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                                <div className="modal-header border-0 pb-1">
                                    <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Past Days Setting</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        id="createPastDaysModalClose"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        onClick={clearCreateState}
                                    />
                                </div>
                                <div className="modal-body pt-2 pb-2">
                                    <div className="float-input-wrap">
                                        <input
                                            type="number"
                                            className={error ? "is-invalid" : ""}
                                            placeholder=" "
                                            value={days}
                                            min="0"
                                            onChange={(e) => { setDays(e.target.value); if (e.target.value !== "") setError(""); }}
                                        />
                                        <label>Past Days*</label>
                                    </div>
                                    {error && <small className="text-danger mt-1 d-block">{error}</small>}
                                </div>
                                <div className="modal-footer border-0 pt-1">
                                    <button
                                        type="button"
                                        className="btn btn-primary waves-effect waves-light"
                                        style={{ borderRadius: "5px", fontSize: "13px" }}
                                        onClick={handelSubmit}
                                    >
                                        + Create Past Days
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                {/* Edit Modal */}
                <div
                    id="editPastDaysModal"
                    className="modal fade"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                    data-bs-keyboard="false"
                >
                    <form onSubmit={handelEditSubmit}>
                        <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
                            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                                <div className="modal-header border-0 pb-1">
                                    <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Past Days Setting</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        id="editPastDaysModalClose"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        onClick={clearEditState}
                                    />
                                </div>
                                <div className="modal-body pt-2 pb-2">
                                    <div className="float-input-wrap">
                                        <input
                                            type="number"
                                            className={error ? "is-invalid" : ""}
                                            placeholder=" "
                                            value={daysEdit}
                                            min="0"
                                            onChange={(e) => { setDaysEdit(e.target.value); if (e.target.value !== "") setError(""); }}
                                        />
                                        <label>Past Days*</label>
                                    </div>
                                    {error && <small className="text-danger mt-1 d-block">{error}</small>}
                                </div>
                                <div className="modal-footer border-0 pt-1">
                                    <button
                                        type="button"
                                        className="btn btn-primary waves-effect waves-light"
                                        style={{ borderRadius: "5px", fontSize: "13px" }}
                                        onClick={handelEditSubmit}
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default PastDaysSettings;
